export const PERSONAL_FIELDS = {
    ACCOUNT_TYPE: 'accountType',
    COMPANY_NAME: 'companyName',
    FIVERR_SELLER_USERNAME: 'sellerUserName',
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    EMAIL: 'email',
    USERNAME: 'username',
    PASSWORD: 'password',
    CONFIRM_PASSWORD: 'confirmPassword',
    COUNTRY: 'country',
    LANGUAGE: 'language',
    TELEGRAM: 'telegram',
    HAS_SOURCE_OF_TRAFFIC: 'hasSourceOfTraffic',
    MAIN_SOURCE_OF_TRAFFIC: 'mainSourceOfTraffic',
    SOCIAL_MEDIA_URL: 'socialMediaUrl',
};
